"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// import PropTypes from 'prop-types';
// Styles
require("./Version.css");
function Version(props) {
    // props
    var debug = props.debug, development = props.development, version = props.version, lastUpdate = props.lastUpdate;
    // console.log('pkg',pkg);
    // if(!!debug) console.log('development',development);
    // if(!!debug) console.log('version',version);
    // if(!!debug) console.log('lastUpdate',lastUpdate);
    // if(!pkg)
    //   return null;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "version" }, { children: [!!development ? 'dev' : null, (0, jsx_runtime_1.jsx)("br", {}, void 0), version, (0, jsx_runtime_1.jsx)("br", {}, void 0), !!lastUpdate ? lastUpdate : null] }), void 0));
}
exports.default = Version;
//# sourceMappingURL=Version.js.map